import moment from 'moment-timezone';
import { sprintf } from 'sprintf-js';

import timezones from '@/components/SelectTimezone/timezones.json';

import Duration from './duration';

export const dateFormat = 'D MMM YYYY';

// profiles.timezone is free text, and moment.tz does not reject a zone it does not know: it
// silently reads the wall clock as UTC. Every caller that hands a profile timezone to moment
// has to fall back to the browser's zone first, so they all share this one definition.
export function resolveTimezone(timezone?: string | null) {
  return timezone && moment.tz.zone(timezone) ? timezone : moment.tz.guess();
}

function getMomentTimezone(timezone: any) {
  return moment.tz(resolveTimezone(timezone));
}

export function getTimezoneDescription(timezone: any) {
  return `(${getGMTOffset(timezone)}) ${getTimezoneName(timezone)}`;
}

function getTimezoneName(timezone: any) {
  const momentTimezone = getMomentTimezone(timezone);
  const timezoneObject = timezones.find((t: any) => t[0] === timezone);
  const timezoneDescription = timezoneObject ? timezoneObject[1] : momentTimezone.format('z');
  return `${timezoneDescription}`;
}

export function getGMTOffset(timezone: any) {
  const momentTimezone = getMomentTimezone(timezone);
  const timezoneOffset = momentTimezone.format('Z');
  return `GMT${timezoneOffset}`;
}

export function isRedZone(time: any, timezone: any) {
  try {
    const hours = moment.tz(time, timezone).hours();
    return hours >= 22 || hours < 8;
  } catch {
    return false;
  }
}

export function getUserTime(time: any, timezone: any, firtName: any) {
  try {
    return `${moment.tz(time, timezone).format('h:mma').toUpperCase()} for ${firtName}`;
  } catch {
    return '';
  }
}

export function formatSeconds(seconds: number) {
  // @ts-expect-error TS(2345): Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
  const hr = parseInt(seconds / 3600);
  if (hr > 0) {
    let sec = seconds % 3600;
    const min = sec / 60;
    sec = Math.abs(sec % 60);
    return sprintf('%02d:%02d:%02d', hr, min, sec);
  }

  const min = seconds / 60;
  const sec = Math.abs(seconds % 60);
  return sprintf('%02d:%02d', min, sec);
}

export class TimeRange {
  end: any;
  start: any;
  // Using moment instead of Date
  constructor(start: moment.Moment, end: moment.Moment) {
    if (start.isAfter(end)) throw new Error('TimeRange start must be before or same as end');
    this.start = start;
    this.end = end;
  }

  overlap(r2: any) {
    let { start } = this;
    let { end } = this;

    if (r2.start.isAfter(this.start)) {
      start = r2.start;
    }

    if (r2.end.isBefore(this.end)) {
      end = r2.end;
    }

    return start && end && start.isBefore(end) ? new TimeRange(start, end) : undefined;
  }

  duration() {
    return new Duration(this.end.diff(this.start));
  }

  overlaps(r2: any) {
    return !!this.overlap(r2);
  }

  isBefore(range: any) {
    return this.start.isBefore(range.start);
  }

  add(quantity: any, unit: any) {
    this.start.add(quantity, unit);
    this.end.add(quantity, unit);
  }
}
